import { useState, FormEvent, useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function AdvertisePage() {
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    document.title = "Advertise With L+TV | L+TV TÉLÉVISION";
  }, []);

  const adServices = [
    { title: t("advertise.svc.tv.title"), description: t("advertise.svc.tv.desc") },
    { title: t("advertise.svc.web.title"), description: t("advertise.svc.web.desc") },
    { title: t("advertise.svc.program.title"), description: t("advertise.svc.program.desc") },
    { title: t("advertise.svc.content.title"), description: t("advertise.svc.content.desc") },
    { title: t("advertise.svc.video.title"), description: t("advertise.svc.video.desc") },
    { title: t("advertise.svc.social.title"), description: t("advertise.svc.social.desc") },
    { title: t("advertise.svc.event.title"), description: t("advertise.svc.event.desc") },
  ];

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    (e.currentTarget as HTMLFormElement).reset();
  };

  return (
    <div className="pt-20">
      <div className="bg-primary-900 py-8">
        <div className="ltv-container">
          <h1 className="text-2xl md:text-3xl font-bold text-white">{t("advertise.title")}</h1>
          <p className="text-white/60 text-sm mt-1">{t("advertise.subtitle")}</p>
        </div>
      </div>

      <div className="ltv-container py-8 md:py-12">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-foreground-700 leading-relaxed text-lg">
            {t("advertise.intro")}
          </p>
        </div>

        <h2 className="ltv-section-title">{t("advertise.servicesTitle")}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {adServices.map((s) => (
            <div key={s.title} className="bg-white rounded-lg border border-background-200 p-5">
              <h3 className="font-semibold text-foreground-900 mb-2">{s.title}</h3>
              <p className="text-sm text-foreground-600">{s.description}</p>
            </div>
          ))}
        </div>

        {/* Enquiry Form */}
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-lg border border-background-200 p-6 md:p-8">
            <h2 className="text-lg font-bold text-foreground-900 mb-2">{t("advertise.formTitle")}</h2>
            <p className="text-sm text-foreground-600 mb-6">{t("advertise.formDesc")}</p>

            {submitted ? (
              <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center text-white mx-auto mb-3">
                  <i className="ri-check-line text-xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-green-800 mb-1">{t("advertise.receivedTitle")}</h3>
                <p className="text-sm text-green-700">{t("advertise.receivedDesc")}</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1">{t("advertise.fullName")} *</label>
                    <input name="name" type="text" className="ltv-input" placeholder={t("contact.yourName")} required />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1">{t("advertise.email")} *</label>
                    <input name="email" type="email" className="ltv-input" placeholder="your@email.com" required />
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1">{t("advertise.company")}</label>
                    <input name="company" type="text" className="ltv-input" placeholder={t("advertise.company")} />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1">{t("advertise.phone")}</label>
                    <input name="phone" type="tel" className="ltv-input" placeholder="+237 ..." />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1">{t("advertise.service")} *</label>
                  <select name="service" className="ltv-input bg-white" required>
                    <option value="">{t("advertise.selectService")}</option>
                    {adServices.map((s) => (
                      <option key={s.title} value={s.title}>{s.title}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1">{t("advertise.message")}</label>
                  <textarea name="message" rows={4} className="ltv-input resize-none" placeholder={t("advertise.messagePlaceholder")} maxLength={500}></textarea>
                </div>
                <button type="submit" className="ltv-btn-accent w-full sm:w-auto">
                  {t("advertise.submit")}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}